import React from "react";
import { useHistory } from "react-router-dom";
import { FaLinkedinIn, FaFacebookF, FaInstagram, FaYoutube } from "react-icons/fa6";

function Footer() {

  const history = useHistory();
  const gotoPage2 = (field) => {
    history.push(field ? `/${field}` : "/");
  };

  return (
    <>
      <footer className="bg-[#183889]">
        <div className="flex flex-col justify-start w-full h-full pt-16 pb-8 2xl:w-9/12 xl:w-11/12 xl:px-0 px-4 mx-auto">
          <div className="grid grid-cols-1 gap-8 lg:grid-cols-3 pb-6">
            <div>
              <img src="/img/happiest-workplace-logo-white.svg" className="" alt="logo" />
              <p className="max-w-xs mt-4 text-base text-white">HappyPlus Consulting is on a mission to reshape the narrative around workplace happiness and wellbeing. </p>
            </div>
            <div className="grid grid-cols-1 gap-8 lg:col-span-2 sm:grid-cols-2 lg:grid-cols-3">

              <div>
                <p className="text-xl font-semibold text-white">HWR Conclave</p>
                <nav className="flex flex-col mt-4 space-y-2 text-base text-white">
                  <div onClick={() => gotoPage2("happiest-workplaces-conclave-2027")} className="hover:text-[#E91E63] cursor-pointer">Happiest Workplaces Conclave 2027</div>
                  <div onClick={() => gotoPage2("happiest-workplaces-conclave-2026")} className="hover:text-[#E91E63] cursor-pointer">Happiest Workplaces Conclave 2026</div>
                  <div onClick={() => gotoPage2("happiness-and-wellbeing-conclave-2025")} className="hover:text-[#E91E63] cursor-pointer">Happiness and Wellbeing Conclave 2025</div>
                  <div onClick={() => gotoPage2("happiness-and-wellbeing-conclave-2023")} className="hover:text-[#E91E63] cursor-pointer">Happiness and Wellbeing Conclave 2023</div>
                  <div onClick={() => gotoPage2("happiness-and-wellbeing-conclave-2022")} className="hover:text-[#E91E63] cursor-pointer">Happiness and Wellbeing Conclave 2022</div>
                </nav>
              </div>

              <div className="">
                <p className="text-xl font-semibold text-white lg:text-center">Resources</p>
                <nav className="flex flex-col justify-center lg:items-center mt-4 space-y-2 text-base text-white">
                  <div onClick={() => gotoPage2("news")} className="hover:text-[#E91E63] cursor-pointer">News</div>
                  <div onClick={() => gotoPage2("blog")} className="hover:text-[#E91E63] cursor-pointer">Blog</div>
                  <div onClick={() => gotoPage2("about-us")} className="hover:text-[#E91E63] cursor-pointer">About</div>
                  {/* <div onClick={() => gotoPage2("privacy-policy")} className="hover:opacity-75 cursor-pointer">Privacy Policy</div> */}
                  {/* <div onClick={() => gotoPage2("faq")} className="hover:opacity-75 cursor-pointer">FAQ</div> */}
                </nav>
              </div>

              <div>
                <p className="text-xl font-semibold text-white">Contact</p>
                <nav className="flex flex-col mt-4 space-y-2 text-base text-white">
                  <a className="" href="mailto:connect@happyplus.in">Mail: connect@happyplus.in</a>
                  <p>Address: HappyPlus Consulting Pvt. Ltd. Express Zone, Western Express Highway, Malad East, Mumbai - 400097</p>
                  <div className="flex pt-6 space-x-4 text-white">

                    <div className="flex items-center justify-center gap-2 flex-wrap">
                      <a href="https://www.facebook.com/people/Happy-Consulting/100075972534354/#" target="_blank" className="bg-white p-2 rounded-lg flex items-center border border-gray-300 justify-center transition-all duration-500 hover:border-[#E91E63] hover:bg-[#E91E63] group">  <FaFacebookF className="w-5 h-5 text-[#212121] group-hover:text-white transition-all duration-500" /></a>
                    </div>
                    <div className="flex items-center justify-center gap-2 flex-wrap">
                      <a href="https://www.linkedin.com/company/happy-consultancy/posts/?feedView=all" target="_blank" className="bg-white p-2 rounded-lg flex items-center border border-gray-300 justify-center transition-all duration-500 hover:border-[#E91E63] hover:bg-[#E91E63] group">
                        <FaLinkedinIn className="w-5 h-5 text-[#212121] group-hover:text-white transition-all duration-500" />
                      </a>
                    </div>
                    <div className="flex items-center justify-center gap-2 flex-wrap">
                      <a href="https://www.instagram.com/happyplus_consulting/" target="_blank" className="bg-white p-2 rounded-lg flex items-center border border-gray-300 justify-center transition-all duration-500 hover:border-[#E91E63] hover:bg-[#E91E63] group">
                        <FaInstagram className="w-5 h-5 text-[#212121] group-hover:text-white transition-all duration-500" />
                      </a>
                    </div>
                    <div className="flex items-center justify-center gap-2 flex-wrap">
                      <a href="https://www.youtube.com/channel/UCqobi-Qguom35WNs_kI5dvA" target="_blank" className="bg-white p-2 rounded-lg flex items-center border border-gray-300 justify-center transition-all duration-500 hover:border-[#E91E63] hover:bg-[#E91E63] group">
                        <FaYoutube className="w-5 h-5 text-[#212121] group-hover:text-white transition-all duration-500" />
                      </a>
                    </div>

                  </div>
                </nav>
              </div>
            </div>
          </div>
          <div className="flex justify-center items-center border-t border-[#4660a1]">
            <p className="mt-6 text-base text-white">All rights reserved | Copyright © 2026 Happiest Worlplaces.</p>
          </div>
        </div>
      </footer>
    </>
  );
}

export default Footer;
